import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAvatar from "components/SoftAvatar";
import swal from "sweetalert2";
import bruce from "assets/images/bruce-mars.jpg";
import { api } from "utils/Api";
// import EditFormPopup from "layouts/admin/user/data/EditForm";
import DeleteForm from "layouts/admin/Organization/DeleteForm";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SmartTableCard from "utils/Smart Table/SmartTableCard";
import ConciergeAddToUnit from "./ConciergeAddToUnit";
import EditFormPopup from "layouts/admin/user/data/EditForm";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { Box, Tooltip } from "@mui/material";
import { useHierarchy } from "context/HierarchyContext";
import { useMemo } from "react";
import RemoveFromParentForm from "layouts/admin/Organization/MultipleDeleteForm";
import { showError } from "utils/messageAlerts";
import { showSuccess } from "utils/messageAlerts";
import RestoreIcon from "@mui/icons-material/Restore";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ConfirmDialog from "utils/ConfirmDialog";
import { getSecureItem } from "utils/SecureStorage";
import MultiConfirmDialog from "utils/MultiConfirmDialog";

function Concierge() {
  const [concierge, setConcierge] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [ property, setProperty ] = useState([]);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [selectedConcierge, setSelectedConcierge] = useState(null);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const [propertyFilterAnchor, setPropertyFilterAnchor] = useState(null);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [propertySearch, setPropertySearch] = useState("");
  const { orgId } = useHierarchy();
  // const orgIdForRestore = JSON.parse(getSecureItem("currentUser"))?.organization_id;
  const roleId = JSON.parse(getSecureItem("currentUser"))?.role_id;
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    type: null,
    concierge: null,
    property: null,
  });

  useEffect(() => {
    fetchConcierge();
    fetchProperties();
  }, []);

  // Fetch all users, then filter only role_id === 3 (Concierge)
  const fetchConcierge = async () => {
    let role_id = 4; // Concierge role_id
    try {
      const userData = await api.getFiltertedUser.getFiltertedUser({ role_id, organization_id: parseInt(orgId) });
      const formatted = userData.map((u) => ({
        id: u.id,
        username: u.username,
        first_name: u.first_name,
        last_name: u.last_name,
        email: u.email,
        phone_number: u.phone_number,
        description: u.description,
        active: u.active,
        image: u.image || null,
        organization_id: u.organization_id,
        role_id: u.role_id,
        createdAt: u.created_at,
        property_id: u.property_id,
        user_property: u.user_property || null,
      }));
      
      setConcierge(formatted);
    } catch (e) {
      setConcierge([]);
    }
  };

  const fetchProperties = async () => {
    try {
      const response = await api.su_Property.getSuProperties();
      setProperty(response);
    } catch (e) {
    }
  };

  // Edit Concierge
  const handleEditConcierge = (concierge) => {
    setSelectedConcierge(concierge);
    setIsEditPopupOpen(true);
  };

  // Delete Concierge
  const handleDeleteConcierge = async (payload) => {
    try {
      await api.su_Property.deleteUserFromProperty(payload);

      showSuccess("Concierge removed from property");

      fetchConcierge();
    } catch (err) {
      
    }
  };

  // Search Concierge
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const propertyMap = useMemo(() => {
    const map = {};
    property.forEach((p) => {
      map[p.id] = p.name;
    });
    return map;
  }, [property]);

  const filteredConcierge = concierge.filter((concierge) => {
    const term = searchTerm.toLowerCase();

    const matchesSearch =
      !searchTerm.trim() ||
      concierge.first_name?.toLowerCase().includes(term) ||
      concierge.last_name?.toLowerCase().includes(term) ||
      concierge.email?.toLowerCase().includes(term) ||
      concierge.username?.toLowerCase().includes(term);

    const matchesProperty =
      selectedProperties.length === 0 ||
      concierge.user_property?.some((up) => selectedProperties.includes(up.property_id));
                                                                                                                    

    return matchesSearch && matchesProperty;
  });

  const filteredPropertyList = property
    .filter((p) => p.organization_id === Number(orgId))
    .filter((p) => p.name.toLowerCase().includes(propertySearch.toLowerCase()));

  const handleConciergeAction = async (property_id) => {
    const { concierge, type } = confirmDialog;

    if (!property_id) return;
    const isDelete = type === "delete";
    try {
      if (isDelete) {
        await api.su_Property.hardDeletePropertyUser({
          property_id,
          user_id: concierge.id,
          organization_id: orgId,
          user_role_id: 4,
        });

        showSuccess("Concierge permanently deleted successfully");
      } else {
        await api.su_Property.restorePropertyUser({
          property_id,
          user_id: concierge.id,
          organization_id: orgId,
          current_user_role_id: roleId,
        });

        showSuccess("Concierge restored successfully");
      }

      fetchConcierge();
    } catch (e) {
      // console.error(e);
    }

    setConfirmDialog({ open: false, type: null, concierge: null, property: null });
  };
  
  return (
    <SmartTableCard
      title={`All Concierge`}
      headerRight={[
        <SoftButton
          key="add-btn"
          variant="outlined"
          color="info"
          size="small"
          onClick={() => setIsAddPopupOpen(true)}>
          New Concierge
        </SoftButton>,
        <SoftInput
          key="search-input"
          placeholder="Search Concierge"
          value={searchTerm}
          onChange={handleSearch}
          size="small"
        />,
      ]}
      columns={[
        { label: "Username", key: "Username", align: "center" },
        { label: "Email", key: "Email", align: "center" },
        { label: "Phone", key: "Phone", align: "center" },
        { label: "Description", key: "Description", align: "center" },
        // { label: "Property", key: "Property", align: "center" },
        {
          label: (
            <SoftBox display="flex" alignItems="center" justifyContent="center" gap="4px">
              <span>Property</span>

              <SoftBox position="relative" display="flex" alignItems="center">
                <FilterAltOutlinedIcon
                  fontSize="small"
                  sx={{
                    cursor: "pointer",
                    color: selectedProperties.length ? "#0284C7" : "#475467",
                    "&:hover": { color: "#0284C7" },
                  }}
                  onClick={(e) => setPropertyFilterAnchor(e.currentTarget)}
                />

                {selectedProperties.length > 0 && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: -4,
                      right: -6,
                      background: "#0284C7",
                      color: "#fff",
                      borderRadius: "50%",
                      fontSize: 10,
                      width: 16,
                      height: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {selectedProperties.length}
                  </Box>
                )}
              </SoftBox>
            </SoftBox>
          ),
          key: "Property",
          align: "center",
        },
        { label: "Active", key: "Active", align: "center" },
        { label: "Actions", key: "Actions", align: "center" },
      ]}
      rows={filteredConcierge.map((concierge) => {
        const validUserProperties = (concierge.user_property || []).filter(
          (uu) => propertyMap?.[uu.property_id]
        );

        const isActive = validUserProperties.some((uu) => uu.active === true);
        const isInactive = !isActive;
      return {
        Username: concierge.username,
        Email: concierge.email,
        Phone: concierge.phone_number,
        Description: concierge.description,
        // Property: property.find((p) => p.id === concierge.property_id)?.name || "N/A",
        Property: (() => {
          if (!concierge.user_property?.length) return "N/A";

          const propertyNames = concierge.user_property
            .filter((up) => up.user_id === concierge.id)
            .map((up) => propertyMap[up.property_id])
            .filter(Boolean);

          return propertyNames.length ? propertyNames.join(", ") : "N/A";
        })(),
        // Active: isActive ? (
        //   <SoftTypography variant="button" color="success" fontWeight="bold">
        //     Yes
        //   </SoftTypography>
        // ) : (
        //   <SoftBox display="flex" justifyContent="center" gap="6px">
        //     {/* Restore */}
        //     <Tooltip title="Restore Concierge" arrow>
        //       <IconButton
        //         onClick={() => handleConciergeActionClick(concierge, "restore")}
        //         sx={{
        //           width: 30,
        //           height: 30,
        //           color: "#16A34A",
        //           backgroundColor: "#ECFDF5",
        //           "&:hover": {
        //             backgroundColor: "#D1FAE5",
        //             transform: "scale(1.1)",
        //           },
        //         }}
        //       >
        //         <RestoreIcon sx={{ fontSize: 18 }} />
        //       </IconButton>
        //     </Tooltip>

        //     {/* Delete */}
        //     <Tooltip title="Delete Permanently" arrow>
        //       <IconButton
        //         onClick={() => handleConciergeActionClick(concierge, "delete")}
        //         sx={{
        //           width: 30,
        //           height: 30,
        //           color: "#DC2626",
        //           backgroundColor: "#FEF2F2",
        //           "&:hover": {
        //             backgroundColor: "#FEE2E2",
        //             transform: "scale(1.1)",
        //           },
        //         }}
        //       >
        //         <DeleteForeverIcon sx={{ fontSize: 18 }} />
        //       </IconButton>
        //     </Tooltip>
        //   </SoftBox>
        // ),
        Active: (() => {
          const inactiveProperty = concierge.user_property?.find((uu) => uu.active === false);
          const activeProperty = concierge.user_property?.find((uu) => uu.active === true);

          if (inactiveProperty) {
            return (
              <SoftBox display="flex" justifyContent="center" gap="6px">
                {/* Restore */}
                <Tooltip title="Restore Concierge" arrow>
                  <IconButton
                    onClick={() =>
                      setConfirmDialog({
                        open: true,
                        type: "restore",
                        concierge,
                        property: inactiveProperty,
                      })
                    }
                    sx={{ color: "#16A34A" }}
                  >
                    <RestoreIcon fontSize="small" />
                  </IconButton>
                </Tooltip>

                {/* Delete */}
                <Tooltip title="Delete Permanently" arrow>
                  <IconButton
                    onClick={() =>
                      setConfirmDialog({
                        open: true,
                        type: "delete",
                        concierge,
                        property: inactiveProperty,
                      })
                    }
                    sx={{ color: "#DC2626" }}
                  >
                    <DeleteForeverIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </SoftBox>
            );
          }

          // ✅ Otherwise show active
          if (activeProperty) {
            return (
              <SoftTypography variant="button" color="success" fontWeight="bold">
                Yes
              </SoftTypography>
            );
          }

          return "N/A";
        })(),
        Actions: (
          <SoftBox display="flex" justifyContent="center" gap="8px">
            <IconButton
              onClick={() => handleEditConcierge(concierge)}
              disabled={isInactive}
              sx={{
                border: "1px solid #D0D5DD",
                backgroundColor: "#F9FAFB",
                width: 34,
                height: 34,
                "& svg": { fontSize: 18 },
                color: "#475467",
                "&:hover": {
                  backgroundColor: "#E0F2FE",
                  borderColor: "#38BDF8",
                  color: "#0284C7",
                },
              }}
            >
              <EditIcon fontSize="sm" />
            </IconButton>

            <IconButton
              onClick={() => {
                setDeletePopupOpen(true);
                setSelectedConcierge(concierge);
              }}
              disabled={isInactive} 
              sx={{
                border: "1px solid #FECACA",
                backgroundColor: "#FEF2F2",
                width: 34,
                height: 34,
                "& svg": { fontSize: 18 },
                color: "#B91C1C",
                "&:hover": {
                  backgroundColor: "#FEE2E2",
                  borderColor: "#F87171",
                  color: "#991B1B",
                },
              }}
            >
              <DeleteIcon fontSize="sm" />
            </IconButton>
          </SoftBox>
        ),
      };
    })}
    >

      <MultiConfirmDialog
        open={confirmDialog.open}
        type={confirmDialog.type}
        title={confirmDialog.type === "delete" ? "Delete Concierge" : "Restore Concierge"}
        description={
          confirmDialog.type === "delete"
            ? "This will permanently delete the concierge. This action cannot be undone."
            : "Are you sure you want to restore this concierge?"
        }
        confirmText={confirmDialog.type === "delete" ? "Delete Permanently" : "Restore"}
        onClose={() => setConfirmDialog({ open: false, type: null, concierge: null, property: null })}
        onConfirm={handleConciergeAction}   
        assignments={confirmDialog.concierge?.user_property || []}
        parentMap={propertyMap}
        idKey="property_id"
        entityLabel="Property"
      />

      {/* EDIT POPUP */}
      {isEditPopupOpen && (
        <EditFormPopup
          mode="edit"
          user={selectedConcierge}
          onClose={() => {
            setIsEditPopupOpen(false);
            fetchConcierge();
          }}
        />
      )}
      {/* ADD POPUP */}
      {isAddPopupOpen && (
        <ConciergeAddToUnit onClose={() => setIsAddPopupOpen(false)} refreshData={fetchConcierge} />
      )}
      {/* {deletePopupOpen && (
        <DeleteForm
          data={selectedConcierge}
          onClose={() => setDeletePopupOpen(false)}
          onDelete={(id) => {
            handleDeleteConcierge(id);
            setDeletePopupOpen(false);
          }}
        />
      )} */}
      {deletePopupOpen && (
        <RemoveFromParentForm
          open={deletePopupOpen}
          entity={selectedConcierge}
          entityLabel="Concierge"
          parentLabel="Property"
          assignments={selectedConcierge?.user_property || []}
          parentKey="property_id"
          parentMap={propertyMap}
          onClose={() => setDeletePopupOpen(false)}
          onRemove={(property_id, user) => {
            handleDeleteConcierge({
              property_id,
              user_id: user.id,
              user_role_id: 4,
              organization_id: orgId,
            });
            setDeletePopupOpen(false);
          }}
        />
      )}

      <Menu
        anchorEl={propertyFilterAnchor}
        open={Boolean(propertyFilterAnchor)}
        onClose={() => setPropertyFilterAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={1}
          py={1}
          gap={1}
        >
          <SoftInput
            placeholder="Search property"
            size="small"
            value={propertySearch}
            onChange={(e) => setPropertySearch(e.target.value)}
          />

          <IconButton
            size="small"
            onClick={() => {
              setPropertyFilterAnchor(null);
              setPropertySearch("");
            }}
          >
            ✕
          </IconButton>
        </Box>

        {/* Clear */}
        {selectedProperties.length > 0 && (
          <MenuItem
            onClick={() => setSelectedProperties([])}
            sx={{ color: "#0284C7", fontWeight: 600 }}
          >
            Clear Selection
          </MenuItem>
        )}

        {/* Property List */}
        {filteredPropertyList.length > 0 ? (
          filteredPropertyList.map((p) => (
            <MenuItem
              key={p.id}
              onClick={() => {
                if (selectedProperties.includes(p.id)) {
                  setSelectedProperties(selectedProperties.filter((id) => id !== p.id));
                } else {
                  setSelectedProperties([...selectedProperties, p.id]);
                }
              }}
            >
              <Checkbox checked={selectedProperties.includes(p.id)} />
              <ListItemText primary={p.name} primaryTypographyProps={{ variant: "body3" }} />
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No properties found</MenuItem>
        )}
      </Menu>
    </SmartTableCard>
  );
}

export default Concierge;